import(/* webpackMode: "eager" */ "/app/node_modules/@apollo/experimental-nextjs-app-support/dist/ssr/ApolloNextAppProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@apollo/experimental-nextjs-app-support/dist/ssr/hooks.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@stadionhq-v3/base-ui/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@stadionhq-v3/contentful-ui/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@stadionhq-v3/football-ui/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/Leeds-United-Teams.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/atoms/localized-date/localizedDate.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/helpers/article-card-renderer/articleCardRenderer.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/helpers/contentful-rich-text-render/contentfulRichTextRender.component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/organisms/broadcasters-wrapper/broadcastersWrapper.component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/templates/loading-template/loadingTemplate.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/layout/profile-layout/profileLayout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["TextButton"] */ "/app/src/components/v3/atoms/button/variants/text-button/text-button.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/v3/organisms/fixture-card-slotted/fixtureCardSlotted.component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/organisms/footer-block/footerBlock.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/v3/organisms/sfa-player-profile-header/sfaPlayerProfileHeader.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/v3/organisms/video-embed/videoEmbed.component.tsx");
